// extracted by mini-css-extract-plugin
export default {"imagesContainer":"PieceOriginalImagesBody_imagesContainer__0FojL"};